import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  QueSonComputosComponent,
  OperacionComputosComponent,
  NavegacionComputosComponent,
  CargosElegiranComponent,
  NormatividadComponent,
  TipoCasillasComponent,
  CatalogoObservacionesComponent,
  PorcentajeActasComponent,
  PreguntasFrecuentesComponent,
  GlosarioComponent,
  BuscadorComponent,
  AcercaVotoComponent,
  CircunscripcionesComponent
} from "./components/index.pagina";

const APP_ROUTES: Routes = [
  // Conoce-Computos
  { path: 'Conoce-Computos/Que-son-los-Computos', component: QueSonComputosComponent },
  { path: 'Conoce-Computos/Operacion-de-Computos', component: OperacionComputosComponent },
  { path: 'Conoce-Computos/Como-buscar-informacion-de-los-computos', component: NavegacionComputosComponent },
  // elecciones Puebla
  { path: 'Eleccion-Puebla/Acerca-del-Voto/:idSeccion', component: AcercaVotoComponent },
  { path: 'Eleccion-Puebla/Cargos-a-elegir', component: CargosElegiranComponent },
  { path: 'Eleccion-Puebla/Circunscripciones', component: CircunscripcionesComponent },
  { path: 'Eleccion-Puebla/Normatividad', component: NormatividadComponent },
  { path: 'Eleccion-Puebla/Tipo-Casillas', component: TipoCasillasComponent },
  // Actas
  { path: 'Actas/Catalogo-Observaciones', component: CatalogoObservacionesComponent },
  { path: 'Actas/Porcentaje-de-Actas-Computadas', component: PorcentajeActasComponent },
  // otros
  { path: 'Buscador/:textobuscado', component: BuscadorComponent },
  { path: 'Glosario/:idSeccion/:idTermino', component: GlosarioComponent },
  { path: 'Preguntas-Frecuentes/:idSeccion/:idPregunta', component: PreguntasFrecuentesComponent },

  { path: '**', pathMatch: 'full', redirectTo: 'Conoce-Computos/Que-son-los-Computos' }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routes.ts